
/**
 * @doc directive
 * @id GraphComment:comment
 *
 * @description directive for comment
 */
angular.module('GraphCommentModule')
  .controller('CommentController', [
    '$scope',
    '$q',
    '$element',
    '$filter',
    '$document',
    '$window',
    '$compile',
    '$log',
    '$sce',
    '$timeout',
    '$translate',
    '$rootScope',
    'CommentService',
    'GcUser',
    'GcECD',
    'ShareService',
    'SliderService',
    'ReadStatusService',
    'FocusService',
    'RecaptchaService',
    'Utils',
    function ($scope, $q, $element, $filter, $document, $window, $compile, $log, $sce, $timeout, $translate, $rootScope,
              CommentService, GcUser, GcECD, ShareService, SliderService, ReadStatusService, FocusService, RecaptchaService, Utils
              ) {
      'use strict';
                
      $scope.CommentService = CommentService;
      $scope.Utils = Utils;
      $scope.motifs = $rootScope.getMotifs();
     
      // max number of children to display (when opening a discussion)
      var MAX_CHILDREN_LOAD = 100;

      // for debugging
      if (window.location.hostname === 'localhost') {
        window.GcUser = GcUser;
      }

      $scope.init = function() {
        /**
         * define a rootCommentId only for root comment
         *  use for focus comment thread
         */
        if ($scope.depth === 0) {
          $scope.rootCommentId = $scope.comment._id;
        }

        if ($scope.toUnbind) $scope.toUnbind.map(unbind => unbind());

        if ($scope.canModerate()) {
          $scope.comment.motif_id = 0;
        }
        if($scope.comment.answer_mode) $scope.answer();

        /**
         * Way to programmaticaly open a comment
         */
        var unbind = $rootScope.$on('comment:' + $scope.comment._id + ':setChildComment', function(event, cmt) {
          $scope.childComment = cmt;
          if (cmt) ReadStatusService.markAsRead(cmt);
          if (cmt && !cmt.is_new) cmt.is_read = true;
        });

        // ignore for child_comments inserted at top-level via websockets
        if (!($scope.depth === 0 && $scope.comment.parent_id)) {

          /**
           * Way to programmaticaly close all comments in the bbf attached to a root comment
           */
          try {
            var rootCommentId = CommentService.getRootComment($scope.comment._id)._id;
            var unbind2 = $rootScope.$on('comment:' + rootCommentId + ':close', function(event, data) {
              $scope.answer_mode = false;

              // if it's a child comment
              if ($scope.comment.parent_id && $scope.depth > data.depth) {
                // Reset the slidebar to the left
                $scope.slide_index = 0;
                $scope.sliderPage = 0;
                $scope.childComment = null;

                // Reset embeds
                $scope.resetEmbedData();
              }
            });
          }
          // if we're on a live notif which is an answer,
          // root comment might not be available
          catch (e) {}
        }

        if($rootScope.searchMode && $rootScope.isPopin){
          $rootScope.$on('comment:' + $scope.comment._id + ':openReply', function(event, cmt) {
            $scope.answer();
          });
        }
       
        $scope.toUnbind = [unbind, unbind2];

        // calculate height of longest answer
        !Utils.isMobile() && $timeout(function() {
          if ($scope.comment.parent_id) {
            // append fake inner-content
            var $content = $element.find('.inner-content').first();
            var $fake = $('<p class="inner-content" style="visibility: hidden"></p>');
            $fake.insertAfter($content);

            var parent = CommentService._comments[$scope.comment.parent_id];
            if (!parent) return;
            var siblings = parent.child_comments;
            var maxHeight = 0;

            // find biggest height
            siblings.forEach(function(sibling) {
              if (sibling.status === 'refused' || sibling.status === 'deleted') return;
              $fake.text(sibling.content.substr(0, 350));
              var height = $fake[0].scrollHeight;
              if (height > maxHeight) maxHeight = height;
            });

            $fake.remove();
            $scope.contentHeight = maxHeight;
          }
        }, 2000);

        hasAlreadyVoted();
      }

      /**
       * Services bindings
       */
      $scope.GcUser = GcUser;
      $scope.FocusService = FocusService;
      $scope.GcECD = GcECD;
      $scope.ReadStatusService = ReadStatusService;
      $scope.SliderService = SliderService;

      $scope.popin = {};

      $scope.embeds = [];

      $scope.$watch(() => FocusService.focusActivated(), function (newValue, oldValue) {
        if (newValue !== oldValue && !$rootScope.votePopin.required) {
          // close vote popin
          $rootScope.votePopin = {};
        }
      });

      /**
       * Refresh read/write status (if user logs in or out, for example)
       */
      $rootScope.$on('read:refresh', function (event, eventOrigin) {
        CommentService.initDataVote(GcUser.getUser());

        $scope.comment.child_comments.forEach(function (child) {
          child.is_read = ReadStatusService.isRead(child._id);
          if (eventOrigin === 'logged_out') {
            // In case of a user disconnecting, clear the is_new status
            child.is_new = false;
            child.has_new_replies = false;
          }
        });
      });

      $scope.getChildComments = function() {
        return CommentService.getThread({
          parent_id: $scope.comment._id,
          offset: 20,
          limit: 10000,
        }).success(function(thread) {
          $scope.comment.child_comments = CommentService._comments[$scope.comment._id].child_comments;
        });
      };

      // When the embed directive finds some embed to display
      $scope.addEmbedData = function (data) {
        data.embedActivated = false;
        $scope.embeds.push(data);
      };

      $scope.resetEmbedData = function () {
        $scope.embeds = [];
      }

      // The user clicks on the embed image
      $scope.onEmbedThumbnailClick = function (embed) {
        if (embed.type === 'video') {
          embed.embedActivated = true;

          if (embed.provider_name === 'YouTube') {
            // Set Youtube iframe to autoplay
            embed.html = embed.html.replace('feature=oembed', 'feature=oembed&autoplay=1');
          }
        }
      };

      // remove file hosted on graphcomment.com domain
      $scope.removeHostedFile = function (embed) {
        var fileIndex = $scope.comment.files.findIndex(function (file) {
          return file._id === embed.fileId;
        });
        $scope.comment.files.splice(fileIndex, 1);

        var embedIndex = $scope.embeds.findIndex(function (e) {
          return e.fileId === embed.fileId;
        });
        $scope.embeds.splice(embedIndex, 1);

        $scope.editComment($scope.comment);
      };

      /**
       * Expand comment
       */
      var timer;

      $scope.expand = function () {
        $scope.comment.expanded = true;
        //mixpanel.track('comment:read_more');
      };

      $scope.expandAfter500ms = function () {
        timer = setTimeout(function () {
          $scope.expand();
          $scope.$apply();
        }, 500);
      };

      $scope.expandAfter1000ms = function () {
        timer = setTimeout(function () {
          $scope.expand();
          $scope.$apply();
        }, 1000);
      };

      $scope.leaveExpand = function () {
        clearTimeout(timer);
      };

      $scope.toggleComment = function(cmt) {
        console.debug('toggleComment, cmt: ', cmt, $scope.bbf3d, $scope.childComment);
        
        if ($rootScope.bbf3dVisible) return $scope.openBbf3d();
    
        // If the active comment is clicked,
        if ($scope.childComment && $scope.childComment._id === cmt._id) {
          $scope.sliderClose();
        } else {
          $scope.showComment(cmt);
          mixpanel.track('comment:show_reply');
        }
      };

      function checkParentsHasNoMorNewComments(cmt) {
        while (cmt.parent_id) {
          cmt = CommentService._comments[cmt.parent_id];
          if (!cmt) break
          cmt.has_new_replies = !!getAllNewComments(cmt).length;
        }

        /***
         * Recursively find all child comments which are still new
         */
        function getAllNewComments(cmt) {
          var newComments = [];
          if (cmt.is_new) newComments.push(cmt);

          cmt.child_comments.find(function(c) {
            newComments = newComments.concat(getAllNewComments(c));
          });

          return newComments;
        }
      }

      /**
       * click on a minibubble to toggle a comment
       */
      $scope.showComment = function showComment(cmt) {
        console.debug('showComment, cmt: ', cmt);

        $scope.answer_mode = false;
        $rootScope.commentOpened = cmt._id;
        $rootScope.lastCommentOpened = CommentService.getLastChildComment(cmt)._id;

        // close all child_comments of current discussion
        try {
          var rootComment = CommentService.getRootComment(cmt._id);
          $rootScope.$broadcast('comment:' + rootComment._id + ':close', {
            depth: $scope.depth,
          });
        }
        // if we're on a live notif which is an answer,
        // root comment might not be available
        catch (e) {}

        // Set comment as read
        ReadStatusService.markAsRead(cmt);
        cmt.is_read = true;
        cmt.is_new = false;

        var prev_slide_index = $scope.slide_index;
        $scope.slide_index = $scope.comment.child_comments.indexOf(cmt) % SliderService.maxVisibleAvatar;

        CommentService.initDataVote(GcUser.getUser());

        if (!cmt.parent_id) {
          throw 'parent not found for ' + JSON.stringify(cmt);
        }

        return CommentService
          .loadChildrenWithParentId(cmt, cmt.parent_id, MAX_CHILDREN_LOAD)
          .then(function (response) {

            // always use the returned comment because it's fresh data
            var freshCmt = response.data.child_comments.find(c => c._id === cmt._id);
            $scope.childComment = angular.extend(cmt, freshCmt);

            checkParentsHasNoMorNewComments(cmt);

            // start opening replies recursively
            if(!$rootScope.searchMode){
              $timeout(function() {
                var currCmt = cmt;
                while (currCmt && currCmt.child_comments.length) {
                  $rootScope.$broadcast('comment:' + currCmt._id + ':setChildComment', currCmt.child_comments[0]);
                  currCmt = currCmt.child_comments[0];
                }
              });
            }
          
            response.data.child_comments.forEach(function (c) {
              c.child_comments.forEach(function (newComment) {
                newComment.is_read = ReadStatusService.isRead(newComment._id);
              });
            });

            // We take the clicked comment position, to make the right page and right position
            var position = 0;
         
            $scope.comment.child_comments.every(function (c) {
              if (c._id !== cmt._id) {
                position++;
                return true;
              }
              return false;
            });

            $scope.sliderPage = Math.floor(position / SliderService.maxVisibleAvatar);
            $scope.slide_index = position % SliderService.maxVisibleAvatar;

            $log.debug('slideTo: ', position, '');
            $log.debug('sliderPage: ', Math.floor(position / SliderService.maxVisibleAvatar));
            $log.debug('slide_index: ', position % SliderService.maxVisibleAvatar);
          });
      };

      /**
       * Share - shorten current link
       */
      $scope.shareComment = function (event) {
        mixpanel.track('comment:share');
        $rootScope.popinShare = {
          placement: event.target,
          comment: $scope.comment,
        };
      };

      $scope.canReport = function() {
        return $rootScope.website && $rootScope.website.offense && $rootScope.website.offense.active;
      };

      $scope.canEdit = function() {
        return (
          GcUser.getUser() &&
          $scope.comment.author &&
          GcUser.getUser()._id === $scope.comment.author._id &&
          !$scope.comment.child_comments.length &&
          $scope.comment.status !== 'refused' &&
          $scope.comment.status !== 'deleted'
        );
      };

      $scope.startEdit = function() {
        $scope.comment.editing = true;
        $scope.comment.initialContent = $scope.comment.content;
      };

      /**
       * Report comment
       */

      var reportComments = false;

      $scope.openReportPopin = function (event) {
        var targetRect = event.target.getBoundingClientRect();
        var commentRect = $element[0].getBoundingClientRect();
        $scope.reportPopinCoord = {
          x: targetRect.left - commentRect.left + targetRect.width / 2,
          y: targetRect.top - commentRect.top - targetRect.height / 2
        };

        var popinWidth = 245;
        var popinMaxLeft = document.body.offsetWidth - popinWidth;
        if ($scope.reportPopinCoord.x > popinMaxLeft) {
          $scope.reportPopinCoord.x = popinMaxLeft;
        }

        if(!reportComments) {
          reportComments = Cookies.get('gc_rs') || [];
        }

        if(reportComments.includes($scope.comment._id)) {
          $scope.alreadyReport = true;
  
        }

        RecaptchaService.getCode().then(function(res) {
          if(res.status === 200)
            $scope.recaptcha = $sce.trustAsHtml(res.data.captcha)
            $scope.recaptchaToken = res.data.token
        })

        $scope.reportSuccess = false;
        $scope.reportData = {};
        $scope.popin.report = true; 
        
        mixpanel.track('comment:report:open', { commentId: $scope.comment._id });
      };

      $scope.closeReportPopin = function() {
        $scope.popin.report = false;
      };

      $scope.reportComment = function() {
        $scope.captchaError = false;
        $scope.reportData.token = $scope.recaptchaToken;
        
        CommentService.report($scope.comment, $scope.reportData).then(function successCallback(e) {
          if(e.status === 200){
            $scope.reportSuccess = true;
            reportComments.push($scope.comment._id);
            Cookies.set('gc_rs', reportComments, { expires: 1, path: '/' });
            mixpanel.track('comment:report:success', { commentId: $scope.comment._id });
            $timeout(function() {
              $scope.closeReportPopin();
            }, 4000);
            return
          }
          if(e.status === 400 && e.data.err){
            $scope.captchaError = true;
            $scope.reportData.captcha = '';
            RecaptchaService.getCode().then(function(res) {
              if(res.status === 200){
                $scope.recaptcha = $sce.trustAsHtml(res.data.captcha)
                $scope.recaptchaToken = res.data.token
              }
            }) 
          }
        }, function errorCallback() {
            $scope.captchaError = true;
            $scope.reportData.captcha = '';
            RecaptchaService.getCode().then(function(res) {
              if(res.status === 200){
                $scope.recaptcha = $sce.trustAsHtml(res.data.captcha)
                $scope.recaptchaToken = res.data.token
              }
            })
          
        });
      };

      $scope.resetRecaptcha = function() {
        $scope.captchaError = false;
        RecaptchaService.getCode().then(function(res) {
          if(res.status === 200){
            $scope.recaptcha = $sce.trustAsHtml(res.data.captcha)
            $scope.recaptchaToken = res.data.token
          }      
        })
      }

      /**
       * (For admins only)
       */

      $scope.canModerate = function() {
        return $rootScope.gcUser && $rootScope.gcUser.can_moderate;
      };

      $scope.canDelete = function() {
        if (
          $rootScope.gcUser &&
          (
            ($scope.comment.author && $scope.comment.author._id === $rootScope.gcUser._id) ||
            $scope.canModerate()
          ) &&
          $scope.comment.status !== 'refused' &&
          $scope.comment.status !== 'deleted'
        ) {
          return true;
        }
      };

      // same as `delete()` but only for admins
      $scope.deleteModal = function(event) {
        event.preventDefault();

        var targetRect = event.target.getBoundingClientRect();
        var popinY = targetRect.top - (450 / 2); // popin's height
        if (popinY > 0) {
          $rootScope.deleteCommentPopinCoord = { y: popinY };
        } else {
          $rootScope.deleteCommentPopinCoord = null;
        }

        $scope.showCommentDeletionPopin = true;
        $scope.showCommentDeletionPopinComment = $scope.comment;
      };

      $scope.commentDeletionPopinOverlayClick = function(event) {
        if (event.target.classList.contains('gc-popin-wrapper')) {
          $scope.hideDeletionPopin();
        }
      };

      $scope.hideDeletionPopin = function() {
        $scope.showCommentDeletionPopin = false;
        $scope.showCommentDeletionPopinComment = null;
      };

      $scope.delete = function() {
        CommentService.remove($scope.comment, $scope.parentComment).success(function () {
          $scope.hideDeletionPopin();

          if (!$scope.comment.child_comments.length || $scope.canModerate()) {
            if ($scope.parentComment) {
              $scope.$parent.sliderClose();
            }

            // fix element not removed
            $('#comment-' + $scope.comment._id).remove();
          }
        });
      };

      $scope.refuse = function() {
        // already refused, do nothing
        if ($scope.comment.status === 'refused') {
          $scope.hideDeletionPopin();
          return;
        }

        CommentService.disapprove($scope.comment).then(function() {
          $scope.hideDeletionPopin();
        });
      };

      $scope.signalAsSpam = function(event) {
        event.preventDefault();
        $translate('are you sure').then(function(msg) {
          if (confirm(msg)) {

            CommentService.signalAsSpam($scope.comment, $scope.parentComment).success(function() {
              if ($scope.parentComment) {
                // remove it from the parent scope
                $scope.$parent.showComment($scope.comment);
              }
            });
          }
        });
      };

      $scope.checkIsBan = function() {
        CommentService.isBan({ comment_id: $scope.comment._id }).success(function(resp) {
          if (resp) {
            // user has been unauthenticated on an other tab, do nothing
            if (resp.gcCode && resp.gcCode === 410) {
              $rootScope.gcUser.can_moderate = false;
              return;
            }

            if (resp.shadow) {
              var banType = 'shadow banned';
            } else if (resp.permanent) {
              var banType = 'unban user';
            } else {
              var banType = 'temporary banned';
            }
            var content = $translate.instant(banType, {
              date: $filter('simpleDate')(resp.date_end),
            });
            $scope.userIsBanned = true;
          } else {
            var content = $translate.instant('ban user');
            $scope.userIsBanned = false;
          }
          $element.find('.gc-action-ban').attr('data-gc-tooltip', content);
        });
      };

      $scope.banUser = function(event, comment) {
        event.preventDefault();

        if ($scope.userIsBanned) return $scope.unBanUser(event, comment);

        if (comment.guest) {
          $rootScope.banPopinUser = comment.cached_author;
          $rootScope.banPopinVisible = true;

          CommentService.getComment(comment._id).success(function(resp) {
            $rootScope.banPopinUser.ip = resp[0].ip;
          });
        } else {
          CommentService.getUserInfos(comment.author._id).success(function(infos) {
            $rootScope.banPopinUser = infos.user;
            $rootScope.banPopinVisible = true;

            CommentService.getComment(comment._id).success(function(resp) {
              $rootScope.banPopinUser.ip = resp[0].ip;
            });
          });
        }

        $rootScope.banPopinCallback = $scope.checkIsBan;

        var targetRect = event.target.getBoundingClientRect();
        var popinY = targetRect.top - (450 / 2); // popin's height
        if (popinY > 0) {
          $rootScope.banPopinCoord = { y: popinY };
        } else {
          $rootScope.banPopinCoord = null;
        }
      };

      $scope.unBanUser = function(event, comment) {
        if (!confirm($translate.instant('unban confirmation'))) return;

        if (comment.guest) {
          doUnBan(comment.cached_author);
        } else {
          CommentService.getUserInfos(comment.author._id).success(function(infos) {
            doUnBan(infos.user);
          });
        }

        function doUnBan(user) {
          CommentService.getComment(comment._id).success(function(resp) {
            user.ip = resp[0].ip;
            var requests = [];
            ['pseudo', 'email', 'ip', 'account'].forEach(function (type) {
              if (type === 'ip' && !user.ip) return;
              if (type === 'pseudo' && !user._id) user.pseudo = user.username; // for guests
              requests.push(CommentService.unban({
                type,
                element: type === 'account' ? null : user[type],
                user: type === 'account' ? user : null,
              }));
            });
            $q.all(requests).then($scope.checkIsBan);
          });
        }
      };


      /**
       *
       * VOTE
       *
       */

      // Once logged verify if he has already voted
      $rootScope.$on('logged_in', function () {
        hasAlreadyVoted();
      });

      // Once the user click on vote
      $scope.startVote = function () {
        $rootScope.votePopin = { comment: $scope.comment };
      };

      $scope.showRealContent = function() {
        if ($scope.comment.status === 'approved' || $scope.comment.status === 'pending') return true;
        if ($scope.comment.shadow && $scope.isOwner()) return true;

        return false;
      };

      $scope.isOwner = function() {
        return $rootScope.gcUser && $scope.comment.author && $scope.comment.author._id === $rootScope.gcUser._id;
      };

      // Hide vote button if already voted
      function hasAlreadyVoted() {
        if (!$scope.comment.rating) $scope.comment.rating = {};
        $scope.comment.rating.has_voted = false;

        // has already voted
        if ($scope.comment.voters && GcUser.getUser()) {
          var vote = $scope.comment.voters.filter(function (item) {
            return item.user === GcUser.getUser()._id;
          });

          if (vote.length === 1) {
            $scope.comment.rating.has_voted = true;
            $scope.comment.rating.vote_rate = vote[0].score;
          }
        }
      }

      /**
       * Switch to editorial mode
       */
      $scope.emitToChild = function () {
        $scope.$broadcast('editorial', { activate: true });
        $rootScope.ecd_creation_mode = !$rootScope.ecd_creation_mode;
      };

      /**
       * Pin comment to the top
       */
      $scope.pinComment = function() {
        CommentService.pin($scope.comment);
      };

      // When receiving editorial message
      $scope.$on('editorial', function (ev, data) {
        $scope.answer_mode = false;
        $scope.ecd_creation_mode = data.activate;
        $scope.comment.editor_choice = false;
      });

      /**
       *
       * ANSWER A COMMENT
       *
       */

      /**
       * (Prepare) Answer to a message
       * make the write-comment directive appear
       */
      $scope.answer = function () {
        // close vote popin
        $rootScope.votePopin = {};

        var rootComment;
        if (!$scope.answer_mode) {
          rootComment = CommentService.getRootComment($scope.comment._id);
        }

        // reload comments (in cas there is new comments)
        /*if ($scope.childComment) {
          $scope.showComment($scope.childComment)
            .then(function() { $scope.childComment = null; });
        }*/

        $scope.answer_mode = !$scope.answer_mode;
        $scope.childComment = null;
        $timeout(function () {
          $scope.$broadcast('comment:create', { id: $scope.comment._id });
        });
      };

      /**
       * (Final) Answer to a message
       * Called by write-comment once comment has been sent
       */
      $scope.addComment = function (data) {

        // Check empty content -> if the user open and close the rating popup repeatedly
        if (data.content.length === 0) {
          return;
        }

        // Set some field on the new object for display
        data.parent_id = $scope.comment._id;

        return CommentService.addMessage(data)
          .success(function (cmt) {
            cmt.is_read = true;

            // Do this just if no error happened (on the Success)
            if (!$scope.bbf3d) {
              $scope.childComment = cmt;

              // Append the new one with all data filled
              $scope.comment.child_comments.unshift(cmt);
            } else {
              // Append the new one with all data filled
              $scope.comment.child_comments.push(cmt);
            }

            $scope.answer_mode = false;

            $scope.slide_index = 0;
            $scope.sliderPage = 0;

            // If SliderService is not initialized, we compute it's value
            $timeout(function () {
              SliderService.computeNbVisibleAvatar();
            }, 0, false);
          })
          .error(function (resp) {
            // An error happened
            $log.error('Cannot send the comment', resp);

            if (resp && resp.gcCode === 411) {
              // The user is not complete
              $log.error('User not complete (missing email)');
            }
          });
      };

      $scope.editComment = function (data) {
        return CommentService.updateMessage(data);
      };

      /**
       * Called by write-comment when click on close comment
       */
      $scope.closeAnswer = function () {
        $scope.answer_mode = false;
      };

      $scope.editorChoice = function () {
        CommentService.ECD.selectAllTree($scope.comment);
      };

      /**
       *
       * SLIDER
       *
       */
      //current bubble index position
      $scope.slide_index = 0;
      $scope.sliderPage = 0;

      $scope.slideTo = function (index) {
        var internalIndex = index + SliderService.maxVisibleAvatar * $scope.sliderPage;
        $scope.showComment($scope.comment.child_comments[internalIndex]);
      };

      $scope.canSlideNext = function () {
        return (
          ($scope.slide_index + SliderService.maxVisibleAvatar * $scope.sliderPage) < ($scope.comment.count_child - 1) &&
          $scope.slide_index < (SliderService.maxVisibleAvatar - 1)
        );
      };

      $scope.sliderNext = function () {
        mixpanel.track('comment:show_next_reply');
        $scope.slideTo(Math.min($scope.slide_index + 1, SliderService.maxVisibleAvatar));
      };

      $scope.canShowArrow = function() {
        return ($scope.slide_index === 0 && $scope.sliderPage === 0) || !$scope.childComment;
      };

      $scope.canSlidePrev = function () {
        return $scope.slide_index > 0 && $scope.childComment;
      };

      $scope.sliderPrev = function () {
        mixpanel.track('comment:show_prev_reply');
        $scope.slideTo(Math.max($scope.slide_index - 1, 0));
      };

      $scope.canShowArrowIcon = function () {
        return $scope.comment.child_comments.length && !$scope.childComment;
      }

      /**
       * Slider page navigation
       * @return {boolean} if slider can slide to next page
       */
      $scope.canSlideNextPage = function () {
        return (
          $scope.slide_index === (SliderService.maxVisibleAvatar - 1) &&
          ($scope.slide_index + $scope.slide_index * $scope.sliderPage) < $scope.comment.count_child - 1
        );
      };

      $scope.sliderNextPage = function () {
        mixpanel.track('comment:show_next_page');
        $scope.getChildComments().then(function() {
          $scope.sliderPage += 1;
          $scope.slideTo(0);
        });
      };

      $scope.canSlidePrevPage = function () {
        return $scope.slide_index === 0 && $scope.sliderPage > 0 && $scope.childComment;
      };

      $scope.sliderPagePrev = function () {
        mixpanel.track('comment:show_prev_page');
        $scope.sliderPage -= 1;
        $scope.slideTo(0);
      };


      $scope.sliderDontOpen = function (event) {
        event.stopPropagation();
      };

      $scope.sliderClose = function () {
        mixpanel.track('comment:close_reply');
        $scope.childComment = null;
        FocusService.desactivate();
      };

      $scope.closeParent = function () {
        $rootScope.$emit('comment:' + $scope.comment.parent_id + ':setChildComment');
      };

      $scope.getRank = function(cmt) {
        if (!cmt.parent_id) return;
        var parent = CommentService._comments[cmt.parent_id];
        if (!parent) return;
        var index = parent.child_comments.findIndex(c => c._id === cmt._id);
        if (index === -1) return;
        return index + 1;
      };


      // Bubble flow 3d
      // ---------------------------------------


      $scope.canOpenBbf3d = function() {
        var bbf3dLevel = $rootScope.website.bbf3d_level;
        if (!bbf3dLevel) return false;
        if ($rootScope.bbf3dVisible && $scope.bbf3d) return true;
        if ($scope.comment.child_comments.length >= bbf3dLevel) return true;
      };

      $scope.openBbf3d = function(event) {
        if (!$scope.canOpenBbf3d()) return;
        mixpanel.track('comment:show_all_replies');

        if (!$rootScope.bbf3dCount) {
          $rootScope.bbf3dVisible = true;
          $rootScope.bbf3dComment = $scope.comment;
        }

        // for nested bbf3d
        else {
          $scope.bbf3dLevel = $rootScope.bbf3dCount;
          $scope.bbf3dVisible = true;
          $scope.bbf3dComment = $scope.comment;

          var unbind = $rootScope.$on('bbf3d-close', function(event, level) {
            if (level === $scope.bbf3dLevel) {
              $scope.bbf3dLevel = null;
              $scope.bbf3dVisible = false;
              $scope.bbf3dComment = null;
            }
          });
        }
      };


      // Fullscreen comment in a popin
      // ---------------------------------------------
      $scope.commentFullscreen= null;
      $scope.openCommentFullscreen = function(event) {
        $rootScope.isPopin = true;
      
        var pos = event.target.getBoundingClientRect();
        var scroll = Utils.getScrollPosition();
        
        if($rootScope.searchMode){
          var top = pos.top + scroll.top - 220 + 'px';
        }else{
          var top = pos.top + scroll.top - 80 + 'px';
        }
        $scope.commentFullscreenTop = top;
        
        CommentService.populate($scope.comment._id).then(function(cmt) {
          // active child comment (all the way to the top comment)
          var c = CommentService.recursiveFind(cmt, $scope.comment._id);
          c.active = true;
         
          while (c.parent_id) {
            c = CommentService._comments[c.parent_id];
            c.active = true;
          }
          
          if($rootScope.searchMode){
            $rootScope.modalFullScreen = true;
            var lastChild = CommentService.getLastChildComment(cmt);
            cmt.defaultId= $scope.comment._id;
            ShareService.shortenUrl(lastChild.thread.url || document.URL, lastChild._id).success(function (data) {
              cmt.url = data.short_url;
              CommentService._comments[cmt._id] = cmt;            
              $rootScope.$broadcast('comment:detail:open', cmt);
            });

          }else{
              // update internal map
              CommentService._comments[cmt._id] = cmt;
              $scope.commentFullscreen = cmt;
          }

        }).catch(function(err) {
          console.log('ERROORR : ', err)
        });
      };

      $scope.openCommentFullscreenAndWriteCommment = function(event) {
        $rootScope.isPopin = true;
        $rootScope.modalFullScreen = true;
        var pos = event.target.getBoundingClientRect();
        var scroll = Utils.getScrollPosition();
        var top = pos.top + scroll.top - 80 + 'px';
        $scope.commentFullscreenTop = top;
        
        CommentService.populate($scope.comment._id).then(function(cmt) {
          var lastChild = CommentService.getLastChildComment(cmt);
          ShareService.shortenUrl(lastChild.thread.url || document.URL, lastChild._id).success(function (data) {
            cmt.url = data.short_url;
            cmt.answer_mode =true;
            $rootScope.$broadcast('comment:detail:open', cmt);
          });
        });
      };

      $scope.closeCommentFullscreen = function() {
        $scope.commentFullscreen = null;
        $rootScope.modalFullScreen = false;
        $rootScope.isPopin = false;
      };

      $scope.populateParent = function() {
        // find index of the comment to populate
        var index = CommentService.comments.findIndex(function(c) {
          return c.isNew && c._id === $scope.comment._id;
        });

        CommentService.populate($scope.comment._id).then(function(cmt) {
          // find index of comment's root
          var existing = CommentService.comments.findIndex(function(c) {
            return c._id === cmt._id;
          });
          // if root is already displayed, remove it
          if (existing !== -1) CommentService.comments.splice(existing, 1);

          // update internal map
          CommentService._comments[cmt._id] = cmt;

          // active child comment (all the way to the top comment)
          var cmt = $scope.comment;
          cmt.active = true;
          while (cmt.parent_id) {
            cmt = CommentService._comments[cmt.parent_id];
            cmt.active = true;
          }

          // replace comment with root comment
          cmt.isShown = true;
          cmt.child_comments.find(c => {
            if (c._id === $scope.comment._id) c.active = true;
          });
          CommentService.comments[index] = cmt;

          $timeout(function() {
            var scrollToEl = $('#comment-' + cmt._id);
            $rootScope.$emit('scrollTo', scrollToEl.offset().top - $rootScope.fixedHeaderHeight);
            FocusService.activate(cmt._id);
          }, 1000);
        });
      };

      $scope.logCmt = function(event) {
        event.preventDefault();
        console.log($scope.comment);
      };

      /**
       * Open a thread of comment
       * only the first with comment.active is opened.
       * The child comments are displayed with scope.childComment
       * compile a new directive and that will call addChildComments (recursive)
       */
      $scope.addChildComments = function () {
        if($scope.comment.isSearch) return;
        // we're doing "minus 2" because for some reasons loading_depth
        // is shiffted by two on the BO, i've no idea why, but we can't change it.
        var loadingDepth = $rootScope.website.loading_depth - 2;

        // overwrite with user's defined loading_depth (if defined)
        var user = GcUser.getUser();
        if (user && typeof user.loading_depth !== 'undefined' && user.loading_depth !== -1) {
          loadingDepth = user.loading_depth;
        }

        // automatically display all children (recursively)
        // - if it's initial page load, display all children according to website.loading_depth
        // - if it's already loaded, we want to display all children (recursively)
        loadingDepth = loadingDepth || MAX_CHILDREN_LOAD;

        // check that root comment has already been displayed once
        // in order to ignore `website.loading_depth` option
        var rootAlreadyDisplayed = $scope.depth > 1 && CommentService.getRootComment($scope.comment._id).already_displayed_once;
        var yakliId = Utils.getParameterByName('comment_id');

        if (
          !$scope.childComment &&
          !$scope.bbf3d &&
          $scope.comment.child_comments.length &&
          $scope.depth !== 0 &&
          $scope.comment._id !== yakliId &&
          (rootAlreadyDisplayed || $scope.depth < loadingDepth)
        ) {
          var cmt = $scope.comment.child_comments[0];
          $scope.childComment = cmt;

          cmt.is_new = false;
          checkParentsHasNoMorNewComments(cmt);
        }

        if ($scope.depth === loadingDepth || $scope.comment.child_comments.length === 0) {
          if (!$scope.comment.parent) { // do nothing if comment is a live comment (no root)
            var root = CommentService.getRootComment($scope.comment._id);
            root.already_displayed_once = true;            
          }
        }

        

        $scope.comment.child_comments
          .map(function (cmt) {
            // init bubble read status
            cmt.is_read = ReadStatusService.isRead(cmt._id);

            return cmt;
          })
          .some(function (cmt, index) {
            if (cmt.active === true) {
              cmt.is_read = true;

              // we should keep it commented, else fullscreen comment popin is not working
              //cmt.active = false;

              $timeout(function () {
                $scope.sliderPage = Math.floor(index / SliderService.maxVisibleAvatar);
                $scope.slide_index = index % SliderService.maxVisibleAvatar;
                $scope.childComment = cmt;
              }, 0);
              return true;
            }
            return false;
          });
      };

      /**
       * Utils
       */
      $scope.initDisplayIndex = function (cmt, $index) {
        if (typeof cmt === 'object') {
          cmt.display_index = $index;
        }
      };

      /**
       * Private Actions
       */
      function findChild(query) {
        var selector = '#comment-' + $scope.comment._id + ' ' + query;
        var node = $document[0].querySelector(selector);
        if (node) {
          return angular.element(node);
        }
        return node;
      }

      // Set the var at true, and after some time, at false (with timeout)
      $scope.notifyViewAvatarChanged = function () {
        $scope.uploader.avatar_changed_done = true;
        $timeout(function () {
          $scope.uploader.avatar_changed_done = false;
        }, 2500);
      };
    }])
  .directive('comment', function () {
    'use strict';
    return {
      replace: true,
      restrict: 'E',
      scope: {
        comment: '=',
        root: '=',
        depth: '=',
        parentId: '@?',
        parentComment: '=?',
        bbf3d: '@?',
        ecdCreationMode: '@',
        searchMode: '@'
      },
      templateUrl: 'comment.html',
      controller: 'CommentController',
      link: function (scope, el/*, attr*/) {
        scope.ecd_creation_mode = (scope.ecdCreationMode === 'true');

        scope.$watch('comment._id', function() {
          // init controller again with new comment
          scope.init();
          // automatically display child comments if they are already populated and active
          scope.addChildComments();
        });

        /**
         * After loading replies for a comment
         * we need to manually update childComments
         */
        scope.$watch('comment', function(comment, prevComment) {
          var hasNewChildren = comment.count_child === prevComment.count_child;
          if (scope.childComment && hasNewChildren) {
            var updated = comment.child_comments.find(function (c) {
              return c._id === scope.childComment._id;
            });
            scope.childComment.child_comments = updated.child_comments;
          }
        }, true);
      }
    };
  });
